module.exports = __webpack_public_path__ + "media/images/items/anim-7-437286de724d9703d128cf422ce77ef3.webp";